import { getSessionId } from '../utils/sessionId';

const isAndroidPOS = () => {
return (
typeof window !== 'undefined' &&
window.AndroidPOS &&
typeof window.AndroidPOS.isAndroidPOS === 'function' &&
window.AndroidPOS.isAndroidPOS() === true
);
};

const isOfflineAndroid = () => {
return (
isAndroidPOS() &&
typeof window.AndroidPOS.isOfflineMode === 'function' &&
window.AndroidPOS.isOfflineMode() === true
);
};

/**

* Create a unique request id for Android → React callbacks.
  */
  const createRequestId = (prefix) => {
  return `${prefix}_${Date.now()}_${Math.random()
   .toString(36)
   .substring(2, 10)}`;
  };

/**

* Make sure the global callback registry exists.
*
* Android calls:
*
* window.__orderArtOfflineCallback(
* requestId,
* responseJson
* )
  */
  const ensureCallbackRegistry = () => {
  if (!window.__orderArtOfflineCallbacks) {
  window.__orderArtOfflineCallbacks = {};
  }
  };




  const getOfflineCart = () => {
return new Promise((resolve, reject) => {
if (!isOfflineAndroid()) {
reject(
new Error(
'Android POS offline bridge unavailable'
)
);
return;
}

if (
  typeof window.AndroidPOS.getOfflineCart !== 'function'
) {
  console.error(
    '[OFFLINE_CART] getOfflineCart is not a function',
    {
      AndroidPOS: window.AndroidPOS,
      getOfflineCart:
        window.AndroidPOS.getOfflineCart,
      type:
        typeof window.AndroidPOS.getOfflineCart
    }
  );

  reject(
    new Error(
      'AndroidPOS.getOfflineCart is not available'
    )
  );
  return;
}

const requestId =
  createRequestId('offline_cart');

ensureCallbackRegistry();

console.log(
  '[OFFLINE_CART] Calling Android getOfflineCart',
  {
    requestId,
    methodType:
      typeof window.AndroidPOS.getOfflineCart
  }
);

window.__orderArtOfflineCallbacks[requestId] = {
  resolve,
  reject
};

try {
  window.AndroidPOS.getOfflineCart(
    requestId,
    String(getSessionId())
  );
} catch (error) {
  delete window.__orderArtOfflineCallbacks[
    requestId
    
  ];

  reject(error);
  return;
}

setTimeout(() => {
  if (
    window.__orderArtOfflineCallbacks[requestId]
  ) {
    delete window.__orderArtOfflineCallbacks[
      requestId
    ];

    reject(
      new Error(
        `Offline cart timeout: ${requestId}`
      )
    );
  }
}, 10000);


});
};




const addOfflineCartItem = ({
  session_id,
  orderType,
  tableId = null,
  productId,
  name,
  quantity = 1,
  unitPrice,
  sizeId = null,
  sizeName = null,
  comments = null,
  extraOptionsJson = null,
  productDetailJson = null
}) => {

  return new Promise((resolve, reject) => {

    if (!isOfflineAndroid()) {
      reject(
        new Error(
          'Android POS offline bridge unavailable'
        )
      );
      return;
    }

    const requestId =
      createRequestId('add_offline_cart');

    ensureCallbackRegistry();

    window.__orderArtOfflineCallbacks[requestId] = {
      resolve,
      reject
    };

    try {

 window.AndroidPOS.addOfflineCartItem(
  requestId,
  String(session_id),
  String(orderType),

  tableId !== null && tableId !== undefined
    ? String(tableId)
    : null,

  String(productId),
  String(name ?? ''),
  Number(quantity),
  Number(unitPrice ?? 0),

  sizeId !== null && sizeId !== undefined
    ? String(sizeId)
    : null,

  sizeName !== null && sizeName !== undefined
    ? String(sizeName)
    : null,

  comments !== null && comments !== undefined
    ? String(comments)
    : null,

  extraOptionsJson !== null &&
  extraOptionsJson !== undefined
    ? String(extraOptionsJson)
    : null,

  productDetailJson !== null &&
  productDetailJson !== undefined
    ? String(productDetailJson)
    : null
);

    } catch (error) {

      delete window.__orderArtOfflineCallbacks[
        requestId
      ];

      reject(error);

      return;
    }

    setTimeout(() => {

      if (
        window.__orderArtOfflineCallbacks[requestId]
      ) {

        delete window.__orderArtOfflineCallbacks[
          requestId
        ];

        reject(
          new Error(
            'Offline add cart timeout'
          )
        );
      }

    }, 10000);

  });
};


/**

* Update quantity of an existing Room cart item.
*
* Android:
*
* updateOfflineCartItem(
* localOrderId,
* localItemId,
* quantity
* )
  */
  const updateOfflineCartItem = ({
  localOrderId,
  localItemId,
  quantity
  }) => {

if (!isOfflineAndroid()) {
throw new Error(
'Android POS offline bridge unavailable'
);
}

window.AndroidPOS.updateOfflineCartItem(
String(localOrderId),
String(localItemId),
Number(quantity)
);
};

/**

* Remove an item from the Room cart.
*
* Android:
*
* removeOfflineCartItem(
* localOrderId,
* localItemId
* )
  */
  const removeOfflineCartItem = ({
  localOrderId,
  localItemId
  }) => {

if (!isOfflineAndroid()) {
throw new Error(
'Android POS offline bridge unavailable'
);
}

window.AndroidPOS.removeOfflineCartItem(
String(localOrderId),
String(localItemId)
);
};

const saveOfflineOrder = ({
  sessionId,
  orderType,
  tableId,
  existingOrderId,
  serverId,
  serviceType,
}) => {
  return new Promise((resolve, reject) => {
    if (!isOfflineAndroid()) {
      reject(
        new Error('Android POS offline bridge unavailable')
      );
      return;
    }

    const requestId =
      createRequestId('save_offline_order');

    ensureCallbackRegistry();

    // window.__orderArtOfflineCallbacks[requestId] = {
    //   resolve,
    //   reject,
    // };

       window.__orderArtOfflineCallbacks[requestId] = {
      resolve: (result) => {
        console.log(
          '[OFFLINE_ORDER] Android returned:',
          JSON.stringify(result, null, 2)
        );

        if (result?.kitchenDocket) {
          console.log(
            '[KITCHEN_DOCKET] Created:',
            JSON.stringify(
              result.kitchenDocket,
              null,
              2
            )
          );
        }

        console.log(
          '[OFFLINE_ORDER] Local order ID:',
          result?.localOrderId
        );

        console.log(
          '[OFFLINE_ORDER] Status:',
          result?.status
        );

        console.log(
          '[OFFLINE_ORDER] Sent to kitchen:',
          !!result?.kitchenDocket
        );

        resolve(result);
      },

      reject: (error) => {
        console.error(
          '[OFFLINE_ORDER] Android returned error:',
          error
        );

        reject(error);
      },
    };
    
    try {
      window.AndroidPOS.saveOfflineOrder(
        requestId,
        String(sessionId),
        String(orderType),
        tableId !== null && tableId !== undefined
          ? String(tableId)
          : null,
        existingOrderId !== null &&
        existingOrderId !== undefined
          ? String(existingOrderId)
          : null,
        serverId !== null &&
        serverId !== undefined
          ? String(serverId)
          : null,
        serviceType !== null &&
        serviceType !== undefined
          ? String(serviceType)
          : null
      );
    } catch (error) {
      delete window.__orderArtOfflineCallbacks[requestId];
      reject(error);
      return;
    }

    setTimeout(() => {
      if (
        window.__orderArtOfflineCallbacks[requestId]
      ) {
        delete window.__orderArtOfflineCallbacks[requestId];

        reject(
          new Error('Offline save order timeout')
        );
      }
    }, 10000);
  });
};

const getOfflineOccupiedTables = () => {
  return new Promise((resolve, reject) => {
    if (!isOfflineAndroid()) {
      reject(
        new Error(
          'Android POS offline bridge unavailable'
        )
      );
      return;
    }

    if (
      typeof window.AndroidPOS.getOfflineOccupiedTables !== 'function'
    ) {
      reject(
        new Error(
          'AndroidPOS.getOfflineOccupiedTables is not available'
        )
      );
      return;
    }

    const requestId =
      createRequestId('offline_occupied_tables');

    ensureCallbackRegistry();

    console.log(
      '[OFFLINE_OCCUPIED] Calling Android getOfflineOccupiedTables',
      {
        requestId
      }
    );

    window.__orderArtOfflineCallbacks[requestId] = {
      resolve,
      reject
    };

    try {
      window.AndroidPOS.getOfflineOccupiedTables(
        requestId
      );
    } catch (error) {
      delete window.__orderArtOfflineCallbacks[
        requestId
      ];

      reject(error);
      return;
    }

    setTimeout(() => {
      if (
        window.__orderArtOfflineCallbacks[requestId]
      ) {
        delete window.__orderArtOfflineCallbacks[
          requestId
        ];

        reject(
          new Error(
            `Offline occupied tables timeout: ${requestId}`
          )
        );
      }
    }, 10000);
  });
};

const getOpenTableOrders = (tableId) => {
  return new Promise((resolve, reject) => {
    if (!isOfflineAndroid()) {
      reject(
        new Error(
          'Android POS offline bridge unavailable'
        )
      );
      return;
    }

    if (
      typeof window.AndroidPOS.getOpenTableOrders !== 'function'
    ) {
      reject(
        new Error(
          'AndroidPOS.getOpenTableOrders is not available'
        )
      );
      return;
    }

    const requestId =
      createRequestId('offline_table_orders');

    ensureCallbackRegistry();

    window.__orderArtOfflineCallbacks[requestId] = {
      resolve,
      reject
    };

    try {
      window.AndroidPOS.getOpenTableOrders(
        requestId,
        String(tableId)
      );
    } catch (error) {
      delete window.__orderArtOfflineCallbacks[requestId];
      reject(error);
      return;
    }

    setTimeout(() => {
      if (
        window.__orderArtOfflineCallbacks[requestId]
      ) {
        delete window.__orderArtOfflineCallbacks[requestId];

        reject(
          new Error(
            `Offline table orders timeout: ${requestId}`
          )
        );
      }
    }, 10000);
  });
};

const getOpenOrderByOrderId = (localOrderId) => {
  return new Promise((resolve, reject) => {
    if (!isOfflineAndroid()) {
      reject(
        new Error(
          'Android POS offline bridge unavailable'
        )
      );
      return;
    }

    if (
      typeof window.AndroidPOS.getOpenOrderByOrderId !== 'function'
    ) {
      reject(
        new Error(
          'AndroidPOS.getOpenOrderByOrderId is not available'
        )
      );
      return;
    }

    if (
      localOrderId === null ||
      localOrderId === undefined ||
      String(localOrderId).trim() === ''
    ) {
      reject(
        new Error(
          'localOrderId is required'
        )
      );
      return;
    }

    const requestId =
      createRequestId('offline_order');

    ensureCallbackRegistry();

    console.log(
      '[OFFLINE_ORDER] Calling getOpenOrderByOrderId',
      {
        requestId,
        localOrderId
      }
    );

    window.__orderArtOfflineCallbacks[requestId] = {
      resolve,
      reject
    };

    try {

      window.AndroidPOS.getOpenOrderByOrderId(
        requestId,
        String(localOrderId)
      );

    } catch (error) {

      delete window.__orderArtOfflineCallbacks[
        requestId
      ];

      reject(error);

      return;
    }

    setTimeout(() => {

      if (
        window.__orderArtOfflineCallbacks[requestId]
      ) {

        delete window.__orderArtOfflineCallbacks[
          requestId
        ];

        reject(
          new Error(
            `Offline order timeout: ${requestId}`
          )
        );
      }

    }, 10000);
  });
};

const getOfflineServers = () => {
  return new Promise((resolve, reject) => {
    if (!isOfflineAndroid()) {
      reject(
        new Error('Android POS offline bridge unavailable')
      );
      return;
    }

    if (
      typeof window.AndroidPOS.getOfflineServers !== 'function'
    ) {
      reject(
        new Error(
          'AndroidPOS.getOfflineServers is not available'
        )
      );
      return;
    }

    const requestId = createRequestId('get_offline_servers');

    ensureCallbackRegistry();

    window.__orderArtOfflineCallbacks[requestId] = {
      resolve,
      reject,
    };

    try {
      window.AndroidPOS.getOfflineServers(requestId);
    } catch (error) {
      delete window.__orderArtOfflineCallbacks[requestId];
      reject(error);
      return;
    }

    setTimeout(() => {
      if (window.__orderArtOfflineCallbacks[requestId]) {
        delete window.__orderArtOfflineCallbacks[requestId];

        reject(
          new Error(
            `Offline get servers timeout: ${requestId}`
          )
        );
      }
    }, 10000);
  });
};

const getOfflineOrders = () => {
  return new Promise((resolve, reject) => {
    if (!isOfflineAndroid()) {
      reject(
        new Error("Android POS offline bridge unavailable")
      );
      return;
    }

    if (
      typeof window.AndroidPOS.getOfflineOrders !== "function"
    ) {
      reject(
        new Error(
          "AndroidPOS.getOfflineOrders is not available"
        )
      );
      return;
    }

    const requestId = createRequestId("offline_orders");

    ensureCallbackRegistry();

    window.__orderArtOfflineCallbacks[requestId] = {
      resolve,
      reject,
    };

    try {
      window.AndroidPOS.getOfflineOrders(requestId);
    } catch (error) {
      delete window.__orderArtOfflineCallbacks[requestId];
      reject(error);
      return;
    }

    setTimeout(() => {
      if (window.__orderArtOfflineCallbacks[requestId]) {
        delete window.__orderArtOfflineCallbacks[requestId];

        reject(
          new Error(
            `Offline orders timeout: ${requestId}`
          )
        );
      }
    }, 10000);
  });
};

export {
isAndroidPOS,
isOfflineAndroid,
getOfflineCart,
getOpenTableOrders,
getOpenOrderByOrderId,
addOfflineCartItem,
updateOfflineCartItem,
removeOfflineCartItem,
saveOfflineOrder,
getOfflineOccupiedTables,
createRequestId,
ensureCallbackRegistry,
getOfflineServers,
getOfflineOrders
};
